import { inject } from '@angular/core';
import { type CanActivateChildFn, Router } from '@angular/router';
import { AuthStore } from '@core/store/core/auth.store';

export const AuthenticationGuard: CanActivateChildFn = async (_route, state) => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  await authStore.checkAuth();

  // checkAuth() is the authoritative answer — it calls oidcSecurityService.checkAuth()
  // internally and patches isAuthenticated only on success. Reading the store signal
  // here avoids racing against isAuthenticated$ which is a BehaviorSubject that can
  // briefly emit false during the renewal token-swap window.
  if (authStore.isAuthenticated()) {
    return true;
  }

  sessionStorage.setItem('redirectTo', state.url);
  router.navigate(['/sign-in']);
  return false;
};
